export const exhibitorStyle = (template) => {
  if (template && template.interaction.exhibitor) {
    const obj = template.interaction.exhibitor;

    const container = obj.frame;
    const title = obj.title;
    const subtitle = obj.subtitle;
    const logo = obj.logo;
    return {
      frame: {
        background:
          container && container.background != "unset"
            ? container.background
            : "rgba(31, 30, 30, 0.4)",
        borderRadius:
          container && container.borderRadius != "unset"
            ? container.borderRadius
            : "4px",
        padding:
          container && container.padding != "unset"
            ? container.padding
            : "10px",
      },
      title: {
        color: title && title.color != "unset" ? title.color : "#fff",
        fontSize:
          title && title.fontSize != "unset"
            ? title.fontSize
            : template.subtitle.fontSize,
        fontWeight:
          title && title.fontWeight != "unset"
            ? title.fontWeight
            : template.subtitle.fontWeight,
        fontFamily:
          title && title.fontFamily != "unset"
            ? title.fontFamily
            : template.subtitle.fontFamily,
      },
      logo: {
        background:
          logo && logo.background != "unset" ? logo.background : "#fff",
        borderRadius:
          logo && logo.borderRadius != "unset" ? logo.borderRadius : "15px",
        width:
          logo && logo.width != "unset" ? logo.width : "300px",
      },
      subtitle: {
        color: subtitle && subtitle.color != "unset" ? subtitle.color : "#fff",
        fontSize:
          subtitle && subtitle.fontSize != "unset"
            ? subtitle.fontSize
            : template.text.fontSize,
        fontWeight:
          subtitle && subtitle.fontWeight != "unset"
            ? subtitle.fontWeight
            : template.text.fontWeight,
        fontFamily:
          subtitle && subtitle.fontFamily != "unset"
            ? subtitle.fontFamily
            : template.text.fontFamily,
      },
    };
  } else {
    return {
      frame: {
        background: "rgba(31, 30, 30, 0.4)",
        borderRadius: "4px",
        padding: "0px",
      },
      logo: { background: "#fff" },
      title: template.subtitle,
      subtitle: template.text,
    };
  }
};
